// Turkish translation — Nexaforge Prospect Solutions (YPE Investment Group)
// Use formal B2B register ("siz" / passive constructs).
// Keep widely-adopted English business terms when natural (Pipeline, Dashboard preview = Gösterge Paneli, etc.).
// Special chars to preserve: ç ğ ı ö ş ü İ.
const tr = {
  demo: {
    recorder_hint: "Ekran kaydınızı şimdi başlatın…",
    starting_hint: "Rehberli demo — 3 saniye içinde başlıyor",
    cancel: "İptal",
    exit: "Çıkış (Esc)",
    pause: "Duraklat (Boşluk)",
    resume: "Devam et (Boşluk)",
    prev: "Önceki sahne (←)",
    next: "Sonraki sahne (→)",
    tts_enable: "Sesli anlatımı etkinleştir",
    tts_disable: "Sesli anlatımı devre dışı bırak",
  },
  common: {
    save: "Kaydet", cancel: "İptal", delete: "Sil", edit: "Düzenle",
    create: "Oluştur", add: "Ekle", search: "Ara", loading: "Yükleniyor…",
    actions: "İşlemler", confirm: "Onayla", close: "Kapat", back: "Geri",
    view: "Görüntüle",
    yes: "Evet", no: "Hayır", all: "Tümü", none: "Hiçbiri", required: "zorunlu",
    saved: "Kaydedildi", deleted: "Silindi", created: "Oluşturuldu", updated: "Güncellendi",
    download: "İndir", import: "İçe aktar", export: "Dışa aktar", upload: "Yükle",
    new: "Yeni", filter: "Filtrele", reset: "Sıfırla",
    copied: "Kopyalandı",
  },
  nav: {
    dashboard: "Gösterge Paneli", companies: "Şirketler", contacts: "Kişiler",
    principals: "Müvekkiller",
    pipeline: "Pipeline", ai_agent: "AI Ajanı", reports: "Raporlar", digest: "Özet",
    discover: "Keşfet",
    approvals: "Onaylar",
    email_perf: "E-posta Perf.",
    ai_coach: "AI Koç",
    quality_audit: "Kalite Denetimi",
    market_intel: "Pazar İstihbaratı",
    api_credits: "API Kredileri",
    private_docs: "Özel Belgeler",
    missions: "Otomatik Görevler",
    data_prep: "Veri (Admin)",
    countries: "Ülkeler", sectors: "Sektörler", users: "Kullanıcılar",
    settings: "Ayarlar", import_export: "İçe / Dışa Aktar", logout: "Çıkış yap",
    light_mode: "Açık tema", dark_mode: "Koyu tema", reference: "Referans",
    administration: "Yönetim",
  },
  auth: {
    welcome_back: "Tekrar hoş geldiniz",
    login_hint: "Çalışma alanınıza erişmek için kimlik bilgilerinizi girin.",
    email: "E-posta", password: "Şifre", name: "Ad",
    sign_in: "Giriş yap", signing_in: "Giriş yapılıyor…",
    no_account: "Hesabınız yok mu?", create_account: "Hesap oluştur",
    already_account: "Zaten kayıtlı mısınız?", sign_up: "Hesabımı oluştur",
    creating: "Oluşturuluyor…",
    tagline_h1: "Sizin yerinize düşünen<br />prospeksiyon CRM'i.",
    tagline_p: "Pazarlarınızı haritalandırın, doğru karar vericileri belirleyin ve kişiselleştirilmiş pitch'ler oluşturun. AI ajanı araştırma işini sizin için yapar.",
    multi_country: "Çok ülkeli", visual_pipeline: "Görsel pipeline", ai_agent: "AI Ajanı",
    live_status: "Canlı · 2026",
    hero_eyebrow: "AI · Çift pipeline · Çok ülkeli",
    hero_eyebrow_v2: "Claude Sonnet 4.5 ile güçlendirildi",
    tagline_h1_v2: "<hl>Daha akıllı</hl> prospeksiyon.<br /><hl>Daha hızlı</hl> kapanış.",
    bullet_1: "AI ajanı şirketleri + karar vericileri gerçek zamanlı keşfeder",
    bullet_2: "Çift pipeline: Müvekkil + Satış (potansiyel müşteriler)",
    bullet_3: "FR/EN/TR · Çok ülkeli · Müvekkil Portalı",
    email_placeholder: "siz@sirketiniz.com",
    mock_pipeline: "Satış Pipeline",
    mock_coach: "Açılma oranını %18 artırın — Salı gönderimlerini saat 10:00'a alın.",
    mock_apply: "Uygula",
    mock_ignore: "Yok say",
    mock_deal_won: "Anlaşma kazanıldı",
    feature_ai_title: "AI Prospeksiyon Ajanı",
    feature_ai_desc: "Claude Sonnet 4.5 sizin için doğru şirketleri ve karar vericileri bulur.",
    feature_pipeline_title: "Çift pipeline",
    feature_pipeline_desc: "Mandat (Müvekkilleriniz) + Satış (potansiyel müşterileriniz), tek yerde.",
    feature_country_title: "Çok ülkeli",
    feature_country_desc: "30+ ülkede sektörleri ve potansiyel müşterileri takip edin.",
    feature_portal_title: "Müvekkil Portalı",
    feature_portal_desc: "Sihirli bağlantı kokpiti + Müvekkilleriniz için aylık PDF raporları.",
    stat_countries: "ülke", stat_pipelines: "pipeline",
    stat_lang: "çoklu dil", stat_ai: "AI aktif",
    security_note: "JWT çerezleri · Çok kiracılı · KVKK/GDPR uyumlu",
    demo_credentials: "",
    split_eyebrow: "AI destekli prospeksiyon platformu",
    split_headline_pre: "Mandalarınızı",
    split_headline_em: "kapanan anlaşmalara dönüştürün.",
    split_sub: "Pazarlarınızı haritalandıran, karar vericileri nitelendiren ve pitch'lerinizi yazan bir AI ajanı. Önemli olana odaklanın: kapanışa.",
    split_feat1: "AI Ajanı · Claude Sonnet 4.5",
    split_feat2: "Çift pipeline · Mandat + Satış",
    split_feat3: "Çok kiracılı · Çoklu dil FR/EN/TR",
    split_stat1_value: "+%87",
    split_stat1_label: "nitelendirme oranı",
    split_stat2_value: "30+",
    split_stat2_label: "kapsanan ülke",
    split_stat3_value: "7/24",
    split_stat3_label: "AI ajanı canlı",
    footer_legal: "© 2026 Nexaforge",
    terms: "Şartlar",
    privacy: "Gizlilik",
    status_operational: "Tüm sistemler çalışıyor",
  },
  dashboard: {
    title: "Gösterge Paneli", subtitle: "Satış faaliyetlerinizin genel bakışı",
    demo_data: "Demo verisi", new_company: "Yeni şirket",
    test_guide: "Test kılavuzu (PDF)",
    test_guide_downloaded: "Test kılavuzu indirildi",
    pitch_pdf: "Pitch deck PDF",
    pitch_downloaded: "Pitch deck indirildi",
    demo_kit: "Demo Kit",
    demo_kit_label: "Satış ve üretim materyalleri",
    pitch_hint: "8 sayfalık müşteri sunumu (otomatik FR/EN)",
    video_kit: "Video Kit (PDF)",
    video_kit_hint: "Senaryo + storyboard + AI araçları",
    video_kit_downloaded: "Video kit indirildi",
    auto_demo_script: "Otomatik demo betiği (.py)",
    auto_demo_hint: "Playwright — uygulama kendi kendini oynatır",
    auto_demo_downloaded: "Otomatik demo betiği indirildi",
    guided_demo: "▶ Rehberli demoyu başlat",
    guided_demo_hint: "Uygulama bu pencerede kendi kendine gezinir",
    demo_data_added: "Demo verisi eklendi ({{companies}} şirket, {{deals}} anlaşma)",
    demo_data_already_present: "Demo verisi zaten mevcut — eklenecek bir şey yok",
    hot_prospects: "Sıcak Potansiyeller",
    see_all: "Tümünü gör",
    hot_empty_title: "Henüz sıcak potansiyel yok",
    hot_empty_hint: "Bir şirket, son 7 günde aktivite veya teklif/müzakere aşamasında bir anlaşma sonrası SICAK olur.",
    hot_reason_stage: "Müzakere aşamasındaki anlaşma",
    hot_reason_recent: "{{n}} gün önce aktivite",
    hot_reason_new: "Yeni sinyal",
    hot_leads: "Takip edilecek sıcak lead'ler",
    hot_leads_empty_title: "Henüz sıcak lead yok",
    hot_leads_empty_hint: "Bir kişi, e-postalarınıza açma, tıklama veya yanıt sonrası sıcak hale gelir.",
    hot_leads_empty_no_signed: "Önce Müvekkiller bölümünde bir Müvekkili 'İmzalandı' olarak işaretleyin.",
    for: "için",
    empty_title: "Demo verisiyle başlayın",
    empty_subtitle: "5 ülke, 6 sektör, 8 şirket ve önceden yapılandırılmış anlaşmalar.",
    load_demo: "Demoyu yükle",
    kpi_companies: "Şirketler", kpi_contacts: "Kişiler", kpi_active_deals: "Aktif anlaşmalar",
    kpi_pipeline_value: "{{value}} € pipeline", kpi_conversion: "Dönüşüm oranı",
    pipeline_evolution: "Pipeline gelişimi (90 gün)",
    by_sector: "Sektöre göre", top_companies_ai: "En iyi şirketler (AI Skoru)",
    no_scored: "Henüz skorlanmış şirket yok. Bir şirket sayfasında \"AI ile zenginleştir\"i kullanın.",
    top_deals: "En iyi anlaşmalar", no_deals: "Henüz anlaşma yok",
    countries_title: "Ülkeler", no_data: "Veri yok",
    data_health_title: "Veri Sağlığı",
    data_health_breakdown: "%{{verified}} doğrulanmış kişi · %{{dm}} karar vericisi olan şirket",
    data_health_tier_excellent: "Mükemmel",
    data_health_tier_good: "İyi",
    data_health_tier_fair: "Orta",
    data_health_tier_poor: "Zayıf",
  },
  coverage: {
    heat_map_title: "Kapsama Isı Haritası",
    target_per_cell: "Hedef: hücre başına {{n}} kişi",
    objectives_btn: "Hedefler",
    loading: "Yükleniyor…",
    no_data: "Henüz kapsama verisi yok.",
    no_data_hint: "Hedef bölgeleri ortaya çıkarmak için Müvekkil başına hedeflerinizi belirleyin.",
    set_objectives: "Hedeflerimi tanımla",
    cell_hint: "Bir hücreye tıklayarak detayları görüntüleyin ve hedefli bir görev başlatın.",
    mandant: "Müvekkil",
    total: "Toplam",
    contacts: "Kişiler",
    verified_emails: "Doğrulanmış e-postalar",
    decision_makers: "Karar vericiler",
    drill_description: "Bu Müvekkil × Ülke kombinasyonu için kapsama detayı.",
  },
  countries: {
    title: "Ülkeler", subtitle: "Coğrafi pazarlarınızı haritalandırın",
    new: "Yeni ülke", edit: "Ülkeyi düzenle", add: "Ülke ekle",
    name: "Ad", code: "ISO Kodu", flag: "Bayrak (emoji)", currency: "Para birimi",
    col_country: "Ülke", col_companies: "Şirketler", col_deals: "Aktif anlaşmalar", col_pipeline: "Pipeline",
    empty: "Ülke yok. Başlamak için bir tane ekleyin.",
    confirm_delete: "Bu ülke silinsin mi?",
  },
  sectors: {
    title: "Sektörler", subtitle: "Hedef endüstrilerinizi kategorize edin (ana → alt-sektörler)",
    new: "Yeni sektör", edit: "Sektörü düzenle", add: "Sektör ekle",
    add_subsector: "Alt-sektör ekle",
    add_subsector_short: "Alt-sektör",
    parent_label: "Ana sektör",
    name: "Ad", description: "Açıklama", icon: "Simge", color: "Renk",
    name_required: "Ad zorunludur",
    empty: "Sektör yok. Başlamak için bir tane ekleyin.",
    confirm_delete: "Bu sektör silinsin mi?",
    companies_attached: "Bağlı şirketler",
    subsectors: "alt-sektör",
    no_subsectors: "Alt-sektör yok. \"Alt-sektör\" veya \"AI Öneri\" ile ekleyin.",
    suggest_ai: "AI Önerisi",
    suggest_ai_hint: "AI'ya alakalı alt-sektör önerileri sorun",
    suggest_title: "\"{{name}}\" için AI önerileri",
    suggesting: "AI en uygun alt-sektörleri düşünüyor…",
    no_suggestions: "Öneri yok. Yeniden deneyin veya manuel ekleyin.",
    no_suggestion_selected: "En az bir öneri seçin.",
    add_selected: "Ekle ({{n}})",
    subsectors_added: "{{count}} alt-sektör eklendi",
  },
  companies: {
    title: "Şirketler", subtitle_count: "{{count}} şirket",
    subtitle_count_plural: "{{count}} şirket",
    new: "Yeni şirket", add: "Şirket ekle",
    add_hint: "Şirketin adını, ülkesini, sektörünü ve rolünü doldurun.",
    name: "Ad", country: "Ülke", sector: "Sektör", website: "Web sitesi",
    linkedin: "LinkedIn URL", size: "Büyüklük",
    search_placeholder: "Ada göre ara…",
    filter_all_countries: "Tüm ülkeler", filter_all_sectors: "Tüm sektörler",
    filter_all_sizes: "Tüm büyüklükler",
    col_company: "Şirket", col_size: "Büyüklük", col_score: "AI Skoru",
    col_contacts: "Kişiler", col_deals: "Anlaşmalar", col_status: "Durum",
    status_enriched: "Zenginleştirildi", status_in_progress: "Devam ediyor", status_pending: "Bekliyor",
    none: "Şirket bulunamadı",
    tag_ai_discovered_hint: "AI keşfi tarafından bulundu",
    role_all: "Tümü",
    linked_principals: "Bağlı Müvekkil(ler)",
    linked_principals_placeholder: "Bir veya daha fazla Müvekkil seçin…",
    linked_principals_hint: "Bu Potansiyel Müşteri, bu Müvekkiller adına hedeflenmektedir.",
    linked_principals_empty: "Henüz bağlı Müvekkil yok.",
  },
  role: {
    label: "Rol",
    principal: "Müvekkil",
    prospect: "Potansiyel Müşteri",
    other: "Diğer",
    hint_principal: "Temsil ettiğiniz şirket — ürünlerini/hizmetlerini Potansiyel Müşterilere satarsınız.",
    hint_prospect: "Nihai müşteri hedefi — bir veya daha fazla Müvekkil adına satış hedefiniz.",
    hint_other: "İş ortağı, tedarikçi, network bağlantısı, rakip — Müvekkil/Potansiyel modeli dışında.",
    principal_status: {
      prospecting: "Prospeksiyon",
      in_discussion: "Görüşülüyor",
      proposal_sent: "Teklif gönderildi",
      signed: "İmzalandı",
      declined: "Reddedildi",
      paused: "Duraklatıldı",
    },
  },
  principals: {
    title: "Müvekkiller",
    subtitle_count: "{{count}} müvekkil",
    subtitle_count_plural: "{{count}} müvekkil",
    new: "Yeni Müvekkil",
    add: "Müvekkil ekle",
    status: "Mandat durumu",
    products_services: "Sunulan ürün ve hizmetler",
    products_services_placeholder: "ör. CRM Yazılımı, 5 günlük Eğitim…",
    products_services_hint: "Bu Müvekkil için ticarileştirdiğiniz her sunumu eklemek için yazın ve Enter'a basın.",
    search_placeholder: "Müvekkil ara…",
    filter_all_status: "Tüm durumlar",
    stats: {
      summary: "Özet",
      in_progress: "Devam eden (görüşme + teklif)",
      total: "Görüntülenen toplam",
      tenant_total: "kiracı toplamı",
      by_status: "Duruma göre",
      by_sector: "En iyi sektörler",
    },
    linked_prospects: "Bağlı potansiyel müşteriler",
    find_prospects_btn: "Potansiyel müşteri bul",
    analyze_dna_btn: "Web sitesini analiz et (DNA)",
    empty_title: "Henüz Müvekkil yok",
    empty_hint: "Müvekkil, temsil ettiğiniz bir şirkettir. Ürünlerini/hizmetlerini Potansiyel Müşterilerinize satarsınız.",
    required_fields: "Ad, ülke ve sektör zorunludur",
    created: "Müvekkil oluşturuldu",
  },
  prospects: {
    title: "{{principal}} için potansiyel müşteri bul",
    target_markets: "Kayıtlı hedef pazarlar",
    target_countries: "Hedef ülkeler",
    target_sectors: "Hedef sektörler",
    search_in_country: "Ülke içinde ara",
    in_sector: "Sektör içinde",
    any_sector: "Herhangi bir sektör",
    find: "Aramayı başlat",
    searching: "Aranıyor…",
    pick_country: "Bir ülke seçin",
    existing_in_db_title: "DB'de mevcut ({{count}})",
    no_existing: "Bu ülkede aynı sektörde DB'nizde henüz şirket yok.",
    new_candidates_title: "Yeni web adayları ({{count}})",
    no_new_candidates: "Yeni aday bulunamadı.",
    tavily_hint: "Yeni şirketlerin web keşfini etkinleştirmek için Ayarlarda Tavily'yi yapılandırın.",
    already_linked: "Bağlandı",
    select_all: "Tümünü seç",
    review_warning: "Her adayı gözden geçirin — Tavily, gerçek şirket olmayan makaleler veya rehberler döndürebilir. Yalnızca gerçek bir şirket web sitesine karşılık gelen öğeleri işaretleyin.",
    quality_medium: "Gözden geçir",
    quality_medium_hint: "Kök URL değil — gerçekten bir şirket sitesi olduğunu doğrulayın.",
    confirm_llm_title: "Claude ile doğrula (önerilir)",
    confirm_llm_hint: "1 cümlelik AI kontrolü kalan yanlış pozitifleri eler.",
    llm_validated: "AI Doğrulandı %{{confidence}}",
    apply: "Bağla / İçe aktar ({{count}})",
    applying: "Uygulanıyor…",
    applied: "✅ {{linked}} şirket bağlandı · {{created}} yeni içe aktarıldı",
  },
  principal_360: {
    title: "360° Görünüm",
    subtitle: "Müvekkil kokpiti",
    prospects_count: "Hedeflenen potansiyel müşteriler",
    contacts: "kişi",
    dms: "karar verici",
    pipeline_value: "Açık pipeline",
    open_deals: "açık anlaşma",
    won_value: "Kazanılan (€)",
    won_deals: "kazanıldı",
    lost_deals: "kaybedildi",
    emails_sent: "Gönderilen e-postalar",
    top_prospects: "En İyi 5 Potansiyel Müşteri (AI skoruna göre)",
    no_prospects_yet: "Bu Müvekkile henüz bağlı Potansiyel Müşteri yok.",
    recent_activity: "Son aktivite (30g)",
    no_activity: "Yakın zamanda aktivite yok.",
    commercializing: "Bu Müvekkil için ticarileştiriyorsunuz",
    export_pdf: "PDF olarak dışa aktar",
    pdf_ready: "PDF raporu oluşturuldu",
  },
  principal_digest: {
    title: "Aylık Müvekkil Özeti",
    subtitle: "Her ayın 1'inde bu Müvekkile 360° PDF raporunu otomatik olarak e-posta ile gönderin.",
    enabled_label: "Aylık otomatik gönderimi etkinleştir",
    viewer_email: "Müvekkil e-postası",
    send_test: "Test gönder",
    hint: "PDF, doğrulanmış alan adınızdan ek olarak gönderilir. Her ayın 1'inde saat 08:00 UTC.",
    sent_to: "Gönderildiği yer",
    recent_sends: "Son gönderimler",
    email_required: "Önce Müvekkilin e-postasını ayarlayın",
  },
  portal_invite: {
    title: "Müvekkil Portalı (salt okunur)",
    button: "Portala davet et",
    hint: "Canlı kokpit + PDF arşivlerine erişim sağlayan 24 saatlik sihirli bir bağlantı gönderir.",
    lang_hint: "Davet e-postası ve raporlar seçilen dilde gönderilir (FR/EN/TR).",
    sent: "Davet gönderildi",
    last_login: "son giriş",
    never_connected: "hiç giriş yapılmadı",
  },
  portal: {
    brand: "Müvekkil Portalı",
    loading: "Yükleniyor…",
    welcome: "{{name}} olarak giriş yapıldı",
    logout: "Çıkış yap",
    nav: {
      cockpit: "Kokpit",
      prospects: "Potansiyel Müşteriler",
      activities: "Aktiviteler",
      digests: "PDF Arşivi",
    },
    login: {
      verifying: "Davetiniz doğrulanıyor…",
      success: "Erişim verildi, yönlendiriliyor…",
      no_token: "Geçersiz davet bağlantısı.",
      help: "Satış temsilcinizden yeni bir davet göndermesini isteyin.",
    },
    cockpit: {
      eyebrow: "CANLI KOKPİT",
      last_update: "Son yenileme:",
      products: "Sizin için ticarileştirilen ürün ve hizmetler",
      top_prospects: "En iyi hedeflenen potansiyel müşteriler (AI skoruna göre)",
      no_prospects: "Henüz bağlı potansiyel müşteri yok.",
      recent_activity: "Son aktivite (30g)",
      no_activity: "Yakın zamanda aktivite yok.",
      kpi: {
        prospects: "Hedeflenen potansiyel müşteriler",
        contacts: "kişi",
        dms: "karar verici",
        pipeline: "Açık pipeline",
        open_deals: "açık anlaşma",
        won: "Onaylanan kazançlar (€)",
        emails: "Gönderilen e-postalar",
      },
    },
    prospects: {
      title: "Sizin için hedeflenen potansiyel müşteriler",
      subtitle: "mandatınıza bağlı potansiyel müşteri",
      empty: "Henüz bağlı potansiyel müşteri yok. Satış temsilciniz çalışıyor.",
    },
    activities: {
      title: "Aktivite zaman çizelgesi",
      subtitle: "Sizin için gerçekleştirilen son 30 günlük satış aksiyonları.",
      empty: "Yakın zamanda aktivite yok.",
    },
    digests: {
      title: "Aylık rapor arşivi",
      subtitle: "Geçmiş aylık PDF raporlarınız.",
      empty: "Henüz rapor gönderilmedi.",
      failed: "Gönderim başarısız",
      download: "İndir",
    },
    pulse: {
      title: "Haftalık nabız",
      last_7d: "· son 7 gün",
      active: "Aktif ajan",
      new_prospects: "Yeni potansiyel müşteriler",
      deals_advanced: "İlerlemiş anlaşmalar",
      emails_sent: "Gönderilen e-postalar",
      activities: "Aktiviteler",
      reassure_active: "Satış ajanınız bu hafta mandatınızda aktif oldu.",
      reassure_quiet: "Sakin bir hafta. Satış ajanınız kısa süre içinde aktiviteye devam edecek.",
    },
    notif: {
      title: "Bildirimler",
      empty: "Henüz bildirim yok.",
      mark_all: "Tümünü okundu olarak işaretle",
    },
  },
  ai_coach: {
    title: "AI Koç",
    analyze_now: "Analiz et",
    last_run: "Son analiz",
    auto: "oto",
    manual: "manuel",
    empty: "Aktif öneri yok.",
    empty_hint: "E-posta performansınızdan reçeteler oluşturmak için 'Analiz et'e tıklayın.",
    sparse_msg: "Yetersiz veri ({{count}} e-posta, min {{min}}). Koçu etkinleştirmek için daha fazla gönderin.",
    run_done: "{{count}} öneri oluşturuldu",
    apply: "Uygula",
    ignore: "Yok say",
    applied: "Uygulandı olarak işaretlendi",
    ignored: "Öneri yok sayıldı",
    confidence: "güven",
  },
  ai_coach_history: {
    title: "AI Koç — Geçmiş ve etki",
    subtitle: "Geçmiş önerileri takip edin ve e-posta performansınız üzerindeki etkiyi ölçün.",
    refresh: "Yenile",
    kpi: {
      total: "Toplam",
      total_hint: "son 90 gün",
      applied: "Uygulandı",
      ignored: "Yok sayıldı",
      pending: "Bekliyor",
    },
    impact: {
      title: "Zaman içinde e-posta performansı",
      subtitle: "son 12 hafta",
      open: "Açılma oranı",
      click: "Tıklama oranı",
      reply: "Yanıt oranı",
      empty: "Bu dönem için e-posta verisi yok.",
      empty_hint: "E-posta gönderin, performans burada görünecek.",
      milestones: "Yakın zamanda uygulanan öneriler",
    },
    list: {
      title: "Öneri geçmişi",
      empty: "Bu filtre için öneri yok.",
    },
    filters: {
      all: "Tümü",
      new: "Bekliyor",
      applied: "Uygulandı",
      ignored: "Yok sayıldı",
      superseded: "Geçersiz kılındı",
    },
    applied_on: "uygulanma tarihi",
    ignored_on: "yok sayılma tarihi",
    reapply: "Yeniden etkinleştir",
    reapplied: "Öneri yeniden etkinleştirildi",
  },
  company_detail: {
    overview: "Genel Bakış", contacts: "Kişiler", offerings: "Ürünler ve Hizmetler",
    competitors: "Rakipler", ai: "AI Analizi", deals: "Anlaşmalar",
    activities: "Aktiviteler", synergy: "Sinerji",
    description: "Açıklama", information: "Bilgi",
    enrich_ai: "AI ile zenginleştir", enriching: "Zenginleştiriliyor…",
    find_decision_makers: "Karar vericileri bul", searching: "Aranıyor…",
    find_contacts_btn: "Kişi bul",
    find_contacts_mode: "Arama tipi",
    mode_dm: "Karar vericiler",
    mode_all: "Tüm kişiler",
    validate_via_claude: "Claude ile doğrula",
    validate_via_claude_hint: "Hunter.io tarafından döndürülen şüpheli ad/e-postaları eler.",
    run_search: "Aramayı çalıştır",
    competitor_ai: "AI analizini çalıştır", analyzing: "Analiz ediliyor…",
    generate_pitch: "Pitch oluştur", generating: "Oluşturuluyor…",
    approach_angles: "Satış yaklaşım açıları",
    pitches_generated: "Oluşturulan pitch'ler",
    no_description: "Açıklama yok. Tam bir analiz oluşturmak için \"AI ile zenginleştir\"i çalıştırın.",
    pain_points: "Acı noktaları", strengths: "Güçlü yönler", weaknesses: "Zayıf yönler",
    opportunities: "Fırsatlar",
    add_note_placeholder: "Hızlı bir not ekle…",
    confirm_delete_company: "\"{{name}}\" ve tüm ilgili veriler kalıcı olarak silinsin mi?",
    no_activity: "Aktivite yok",
    sources_label: "Web kaynakları (Tavily)",
    no_reports: "AI raporu yok. Başlamak için \"AI ile zenginleştir\"e tıklayın.",
    no_competitors_ai: "Rakipleri ve farklılaşma açılarını keşfetmek için AI analizini çalıştırın.",
    no_product: "Ürün algılanmadı", no_service: "Hizmet algılanmadı",
    no_contact: "Kişi yok",
    formal_email: "Resmi e-posta", linkedin_short: "Kısa LinkedIn", punchy_email: "Etkili e-posta",
    subject: "Konu", copy: "Kopyala", copied: "Kopyalandı",
    decision_maker: "Karar verici",
    dm_no_verified_title: "Doğrulanmış karar verici bulunamadı",
    dm_no_verified_hint: "Kişileri uydurmuyoruz. Karar vericileri manuel olarak bulmak için aşağıdaki LinkedIn bağlantılarını kullanın, ardından 'Kişi ekle' ile ekleyin.",
    dm_add_manually_hint: "Doğrulanmış karar verici keşfini otomatikleştirmek için Ayarlarda Apollo.io veya Hunter.io'yu yapılandırın.",
    not_configured: "Yapılandırılmamış",
  },
  company: {
    dm_added: "{{count}} karar verici eklendi (kaynak: {{source}})",
    dm_added_v2: "{{count}} kişi eklendi ({{llm}} AI doğrulamalı) · kaynak: {{source}}",
    dm_no_verified: "Doğrulanmış karar verici bulunamadı — manuel arama gerekli",
  },
  contacts: {
    title: "Kişiler", count: "{{count}} kişi",
    new: "Ekle", add: "Kişi ekle",
    first_name: "Ad", last_name: "Soyad", position: "Pozisyon",
    email: "E-posta", phone: "Telefon", seniority: "Kıdem",
    decision_maker: "Karar verici", source: "Kaynak",
    manual: "Manuel",
    unverified: "Doğrulanmamış",
    search_placeholder: "Ad, soyad, e-posta ara…",
    filter_all_seniorities: "Tüm kıdemler", filter_decision_makers: "Yalnızca karar vericiler",
    filter_all: "Tümü",
    col_contact: "Kişi", col_company: "Şirket", col_position: "Pozisyon",
    col_contact_info: "İletişim bilgisi", col_seniority: "Kıdem", col_source: "Kaynak",
    empty: "Kişi yok",
    verified: "Doğrulandı",
    send: "Gönder", call: "Ara", open: "Aç", close: "Kapat",
    open_company: "Şirketi aç",
    save_notes: "Notları kaydet",
    notes: "Notlar",
    notes_placeholder: "Bu kişi hakkında dahili notlar…",
    tab_info: "Bilgi",
    tab_engagement: "Etkileşim",
    emails_sent: "Gönderildi",
    emails_opened_kpi: "Açıldı",
    emails_clicked_kpi: "Tıklandı",
    emails_replied_kpi: "Yanıtlandı",
    emails_bounced_kpi: "Geri döndü",
    deals: "Anlaşmalar",
    last_engagement: "Son aktivite",
    no_engagement: "Bu kişi için henüz etkileşim geçmişi yok.",
    recent_emails: "Son e-postalar",
    linked_deals: "Bağlı anlaşmalar",
    recent_activities: "Son aktiviteler",
    loading: "Yükleniyor…",
    opened: "Açıldı",
    clicked: "Tıklandı",
    replied: "Yanıtlandı",
    bounced: "Geri döndü",
    sort_recent: "En son",
    sort_score: "Önce en sıcak",
    tier_hot: "Sıcak",
    tier_warm: "Ilık",
    tier_tepid: "Hafif sıcak",
    tier_cold: "Soğuk",
    score_explain: "Etkileşim Skoru (90 günlük pencere)",
    opens: "Açılmalar",
    clicks: "Tıklamalar",
    replies: "Yanıtlar",
    bounces: "Geri dönüşler",
    deals_30d: "Anlaşmalar 30g",
    activities_30d: "Aktiviteler 30g",
    multinational_risk: "Çok uluslu alan — doğrulayın",
    entity_verified: "Varlık doğrulandı",
    verify_via_linkedin: "LinkedIn ile doğrula",
  },
  pipeline: {
    title: "Pipeline", subtitle: "Satış fırsatlarınızın Kanban görünümü (Potansiyel Müşteriler)",
    subtitle_mandate: "Müvekkil imza sürecinizin Kanban görünümü",
    tab_sales: "Satış Pipeline",
    tab_mandate: "Mandat Pipeline",
    new_deal: "Yeni anlaşma", create_deal: "Anlaşma oluştur", pdf_ready: "Pipeline PDF'i oluşturuldu",
    deal_title: "Başlık", company: "Şirket", value: "Değer",
    currency: "Para birimi", stage: "Aşama", close_date: "Beklenen kapanış tarihi",
    notes: "Notlar",
    stat_active: "Aktif anlaşmalar", stat_value: "Pipeline değeri",
    stat_won: "Kazanılan", stat_conversion: "Dönüşüm",
    stages: {
      LEAD: "Lead", QUALIFIED: "Nitelendirildi", CONTACTED: "İletişim kuruldu",
      MEETING_SCHEDULED: "Toplantı", PROPOSAL_SENT: "Teklif",
      NEGOTIATION: "Müzakere", WON: "Kazanıldı", LOST: "Kaybedildi",
      IDENTIFIED: "Tespit edildi", IN_DISCUSSION: "Görüşülüyor",
      SIGNED: "İmzalandı", DECLINED: "Reddedildi",
    },
  },
  ai_agent: {
    title: "AI Prospeksiyon Ajanı",
    subtitle: "Claude Sonnet 4.5 · yedek GPT-5.2",
    new_conv: "Yeni konuşma", history: "Geçmiş",
    no_conv: "Konuşma yok",
    welcome: "Bugün ne arıyorsunuz?",
    welcome_sub: "Ajandan şirket bulmasını, potansiyel müşterileri nitelendirmesini veya karar vericiler önermesini isteyin.",
    placeholder: "İsteğinizi yazın… (Göndermek için Enter, yeni satır için Shift+Enter)",
    thinking: "Ajan düşünüyor…",
    confirm_delete_session: "Bu konuşma silinsin mi?",
  },
  reports: {
    title: "AI Raporları", subtitle: "Ajan tarafından oluşturulan tüm analizler",
    empty: "Henüz rapor yok. AI analizi oluşturmak için bir şirketi zenginleştirin.",
  },
  settings: {
    title: "Ayarlar", subtitle: "Profilinizi ve AI ajanını yapılandırın",
    profile: "Profil",
    activity_section: "Faaliyetiniz (AI ajanı tarafından kullanılır)",
    activity_label: "Faaliyet açıklamanız",
    activity_hint: "AI, kişiselleştirilmiş pitch'ler oluşturmak ve cevaplarını bağlamlandırmak için bu metni kullanır.",
    services_label: "Sunduğunuz hizmetler",
    add_service: "Bir hizmet ekleyin…",
    preferences: "Tercihler",
    default_currency: "Varsayılan para birimi", ai_language: "AI dili",
    integrations: "Harici entegrasyonlar",
    integrations_hint: "Gerçek veri zenginleştirmeyi etkinleştirmek için API anahtarlarınızı girin. Anahtarlar şifrelenmiş olarak saklanır ve görüntülendiğinde maskelenir.",
    apollo_key: "Apollo.io anahtarı", hunter_key: "Hunter.io anahtarı",
    tavily_key: "Tavily anahtarı", key_placeholder: "Anahtarınızı yapıştırın…",
    where_to_get: "Nereden alınır?",
    save_settings: "Kaydet",
  },
  users: {
    title: "Kullanıcılar", subtitle: "Hesapları ve erişim haklarını yönetin",
    new: "Yeni hesap", create: "Kullanıcı oluştur", edit: "Kullanıcıyı düzenle",
    email: "E-posta", password: "Şifre", name: "Ad", role: "Rol",
    role_admin: "Admin (tam erişim + yönetim)",
    role_user: "Kullanıcı (düzenleyebilir, sınırlı kapsam)",
    role_viewer: "İzleyici (salt okunur, sınırlı kapsam)",
    access_all: "Tüm verilere tam erişim",
    access_scope: "Erişimi sınırla",
    access_countries: "Erişilebilir ülkeler",
    access_sectors: "Erişilebilir sektörler",
    access_companies: "Belirli şirketler",
    is_active: "Hesap aktif",
    col_user: "Kullanıcı", col_role: "Rol", col_access: "Kapsam",
    col_status: "Durum", col_created: "Oluşturuldu", col_digest: "Özet",
    digest_enabled: "Haftalık özet (e-posta)",
    digest_hint: "Kullanıcı Pazartesi sabahı haftalık özet alacak.",
    digest_enabled_toast: "{{email}} için özet etkinleştirildi",
    digest_disabled_toast: "{{email}} için özet devre dışı bırakıldı",
    digest_test_sent: "Test e-postası {{email}} adresine gönderildi",
    digest_send_test: "Test e-postası gönder",
    confirm_delete: "Bu hesap silinsin mi?",
    cannot_delete_self: "Kendi hesabınızı silemezsiniz",
  },
  import_export: {
    title: "İçe / Dışa Aktar",
    subtitle: "CSV dosyasından toplu veri yükleyin veya veritabanınızı dışa aktarın.",
    templates: "Dosya şablonları",
    templates_hint: "Önceden doldurulmuş bir şablon indirin, verilerinizi doldurun, ardından dosyayı içe aktarın.",
    template_companies: "Şirket şablonu (CSV)",
    template_contacts: "Kişi şablonu (CSV)",
    download_template: "Şablonu indir",
    import: "Dosya içe aktar",
    import_companies: "Şirketleri içe aktar",
    import_contacts: "Kişileri içe aktar",
    choose_file: "Bir CSV dosyası seçin",
    drop_or_click: "Dosyanızı buraya bırakın veya göz atmak için tıklayın",
    importing: "İçe aktarılıyor…",
    export: "Veritabanını dışa aktar",
    export_companies: "Tüm şirketleri dışa aktar",
    export_contacts: "Tüm kişileri dışa aktar",
    export_deals: "Tüm anlaşmaları dışa aktar",
    export_activities: "Tüm aktiviteleri dışa aktar",
    export_filters: "Gelişmiş filtreler",
    export_filters_hint: "CSV dışa aktarımlarınızı tarihe, ülkeye, sektöre, aşamaya ve daha fazlasına göre filtreleyin.",
    filter_date_from: "Başlangıç tarihi (sonra oluşturulan)",
    filter_date_to: "Bitiş tarihi (önce oluşturulan)",
    filter_close_from: "Beklenen kapanış — başlangıç",
    filter_close_to: "Beklenen kapanış — bitiş",
    filter_countries: "Ülkeler",
    filter_sectors: "Sektörler",
    filter_stages: "Aşamalar",
    filter_sizes: "Şirket büyüklükleri",
    filter_seniorities: "Kıdemler",
    filter_owners: "Sahipler",
    filter_activity_types: "Aktivite türleri",
    filter_ai_score_min: "Min AI skoru",
    filter_ai_score_max: "Maks AI skoru",
    filter_value_min: "Min değer (€)",
    filter_value_max: "Maks değer (€)",
    filter_dm_only: "Yalnızca karar vericiler",
    filter_tag: "Etiket (tek)",
    filter_select_placeholder: "—",
    filter_multi_placeholder: "Seçin…",
    filter_reset: "Sıfırla",
    filter_export_now: "Dışa aktar",
    no_filters: "Filtre yok — her şey dışa aktarılıyor.",
    active_filters: "{{count}} aktif filtre",
    active_filters_plural: "{{count}} aktif filtre",
    result_title: "İçe aktarma sonucu",
    result_created: "{{n}} oluşturuldu", result_updated: "{{n}} güncellendi",
    result_skipped: "{{n}} atlandı",
    errors_title: "Atlanan satırlar",
    error_line: "Satır {{line}}",
    notes_title: "Nasıl çalışır?",
    notes: [
      "Şirketler country_code aracılığıyla mevcut bir ülkeye atıfta bulunmalıdır (ör. FR, MA, TR).",
      "Sektör yoksa otomatik olarak oluşturulur.",
      "Kişiler için company_name mevcut bir şirketle eşleşmelidir.",
      "İçe aktarma idempotenttir: bir kopya (aynı ad) güncellenir, çoğaltılmaz.",
    ],
  },
  synergy: {
    title: "Sinerji", legend: "Tam şirket görünümü",
    timeline: "Aktivite akışı", radial: "Radyal görünüm", related: "İlgili şirketler",
    no_timeline: "Bu şirket için henüz kayıtlı olay yok.",
    no_related: "İlgili şirket yok (aynı sektör veya ülke).",
    same_sector: "Aynı sektör", same_country: "Aynı ülke",
    decision_makers: "Karar vericiler", active_pipeline: "Aktif pipeline",
    products: "Ürünler", services: "Hizmetler",
    competitors: "Rakipler", reports: "AI raporları",
    click_hint: "Detayları görmek için bir düğüme tıklayın",
    details_for: "{{name}} için",
    empty_list: "Gösterilecek bir şey yok.",
    decision_maker: "Karar verici",
    explorer_mode: "Kâşif",
    scope_this: "Bu şirket",
    scope_same_sector: "Aynı sektör",
    scope_same_country: "Aynı ülke",
    scope_same_sector_and_country: "Sektör + Ülke",
    explorer_for: "{{name}} için · kapsam: {{scope}}",
    peers_count_one: "{{count}} benzer şirket",
    peers_count_other: "{{count}} benzer şirket",
    peers_count: "{{count}} benzer",
    empty_explorer: "\"{{scope}}\" kapsamına uyan yok.",
    decision_makers_only: "Yalnızca karar vericiler",
    via: "via",
  },
  timeline: {
    company_created: "Şirket veritabanına eklendi",
    deal_created: "Anlaşma oluşturuldu: {{deal}}",
    deal_updated: "Anlaşma güncellendi: {{deal}}",
  },
  errors: {
    network: "Ağ hatası", forbidden: "İşleme izin verilmiyor",
    not_found: "Öğe bulunamadı", validation: "Geçersiz veri",
  },
  digest: {
    title: "Haftalık özet",
    subtitle: "Son 7 günün AI sinyalleri, anlaşma hareketleri ve karar vericilerinin otomatik özeti.",
    preview_email: "E-postayı önizle",
    preview_label: "HTML önizleme",
    send_test_to_me: "Bana test gönder",
    run_now: "Şimdi herkese gönder",
    not_configured: "Resend yapılandırılmamış. Göndermeyi etkinleştirmek için arka uçta RESEND_API_KEY ekleyin.",
    schedule: "Zamanlama",
    schedule_hint: "Özet her hafta bu saatte otomatik olarak gönderilir.",
    my_status: "Aboneliğim",
    enabled: "Etkin",
    disabled: "Devre dışı",
    ask_admin: "Yöneticinize etkinleştirmesini sorun",
    self_disabled: "Özetiniz devre dışı. Yalnızca bir admin yeniden etkinleştirebilir.",
    history_count: "Gönderilen özetler",
    last_sends: "Saklanan kayıtlar",
    current_week: "Bu haftanın önizlemesi",
    kpi_pipeline: "Pipeline", kpi_active: "Aktif anlaşmalar",
    kpi_wins: "Kazanılan (7g)", kpi_new: "Yeni anlaşmalar",
    hot_signals: "🔥 Sıcak AI sinyalleri",
    advanced_deals: "📈 Anlaşma hareketi",
    new_dms: "👤 Yeni karar vericiler",
    stagnant: "⏰ Durağan anlaşmalar (>14g)",
    no_hot: "Bu hafta sıcak sinyal yok.",
    no_movement: "Anlaşma hareketi yok.",
    no_dms: "Yeni karar verici yok.",
    no_stagnant: "Tüm anlaşmalarınız taze.",
    history: "Geçmiş",
    empty_history: "Henüz özet gönderilmedi. 'Bana test gönder'e tıklayın.",
    col_sent_at: "Gönderilme zamanı", col_user: "Kullanıcı",
    col_subject: "Konu", col_status: "Durum",
    sent: "Gönderildi", failed: "Başarısız",
    test_sent: "E-posta {{email}} adresine gönderildi",
    run_done: "{{sent}}/{{total}} özet gönderildi",
    day_mon: "Pazartesi", day_tue: "Salı", day_wed: "Çarşamba",
    day_thu: "Perşembe", day_fri: "Cuma", day_sat: "Cumartesi", day_sun: "Pazar",
  },
  discover: {
    title: "Şirketleri keşfet",
    subtitle: "AI ajanı web'i arar ve tek tıkla ekleyebileceğiniz ilgili potansiyel müşterileri önerir.",
    ai_approved_banner: "Her aday web'den (Tavily) çıkarılır, ardından Claude (Anthropic) tarafından küratörlenir. Uyum skoru (0-100), hizmetleriniz + kriterleriniz karşısında AI tarafından değerlendirilen alakayı yansıtır. ≥ 70 olan adaylar « AI-Onaylı » etiketlenir.",
    ai_approved: "AI-Onaylı",
    form_title: "Arama kriterleri",
    field_countries: "Hedef ülkeler",
    field_sectors: "Hedef sektörler",
    field_services: "Sunduğum hizmetler",
    services_hint: "Ayarlarınızdan önceden dolduruldu. Yalnızca bu arama için düzenleyin.",
    field_criteria: "Ek kriterler (isteğe bağlı)",
    field_limit: "Şirket sayısı",
    placeholder_countries: "Tüm ülkeler",
    placeholder_sectors: "Tüm sektörler",
    placeholder_services: "ör. KOBİ'ler için SaaS CRM",
    placeholder_criteria: "ör. Series A/B startuplar, 50-200 çalışan, e-ticaret büyüme aşaması…",
    companies: "şirket",
    need_tavily: "Tavily API yapılandırılmamış. Keşfi kullanmak için Ayarlar → API Anahtarları'na ekleyin.",
    need_filter: "En azından bir ülke, sektör veya ek kriter girin.",
    run: "Keşfi başlat",
    searching: "Aranıyor…",
    found: "{{n}} potansiyel müşteri tespit edildi",
    saved: "{{created}} eklendi · {{skipped}} zaten vardı",
    sources_used: "AI tarafından kullanılan web kaynakları",
    selected_count: "{{count}}/{{total}} seçildi",
    select_all: "Tümünü seç",
    deselect_all: "Tümünün seçimini kaldır",
    rerun: "Yeniden çalıştır",
    add_selected: "{{count}} şirket ekle",
    add_selected_plural: "{{count}} şirket ekle",
    assign_country: "Ülke",
    assign_sector: "Sektör",
    unassigned: "Atanmamış",
    no_candidates: "Potansiyel müşteri tespit edilmedi. Kriterlerinizi inceltin.",
  },
  notifications: {
    title: "Bildirimler",
    empty: "Bildirim yok.",
    mark_all_read: "Tümünü okundu olarak işaretle",
    view_all: "Tümünü gör",
    just_now: "az önce",
    minutes_ago: "{{n}} dk önce",
    hours_ago: "{{n}} sa önce",
    days_ago: "{{n}} g önce",
    prefs_title: "Bildirim tercihleri",
    prefs_hint: "Ne almak istediğinizi ve nasıl alacağınızı seçin.",
    event_hot_ai_signal: "İzlenen bir şirkette sıcak AI sinyali",
    event_deal_stage_change: "Anlaşma aşaması değişikliği",
    event_new_decision_maker: "Yeni karar verici eklendi",
    event_stagnant_deal: "Durağan anlaşma (>14 gün)",
    col_in_app: "Uygulama içi",
    col_email: "E-posta",
    email_not_configured: "Resend yapılandırılmamış — e-postalar gönderilmeyecek.",
  },
  watch: {
    title: "Otomatik izleme",
    subtitle: "En yüksek öncelikli şirketlerinizdeki haberlerin günlük AI takibi.",
    last_run: "Son çalışma",
    never: "Hiçbir zaman",
    schedule: "Zamanlama: her gün saat {{hour}}:00 UTC",
    run_now: "Benim için şimdi çalıştır",
    no_signals: "Henüz sinyal algılanmadı.",
    signals_count: "{{n}} son sinyal",
    hot_only: "Yalnızca sıcak sinyaller",
    detected_at: "Algılanma zamanı",
    open_company: "Şirketi aç",
  },
  temperature: {
    HOT: "Sıcak", WARM: "Ilık", COLD: "Soğuk",
    hot_short: "🔥", warm_short: "☀️", cold_short: "❄️",
    title: "Sıcaklık",
    filter_all: "Tümü",
    filter_hot: "🔥 Sıcak", filter_warm: "☀️ Ilık", filter_cold: "❄️ Soğuk",
  },
  pdf: {
    export_one: "PDF olarak dışa aktar",
    export_bulk: "Tüm raporları dışa aktar",
    generating: "PDF oluşturuluyor…",
  },
  autopilot: {
    title: "Pipeline Otopilot",
    subtitle: "AI'nın her gün otomatik olarak potansiyel müşterileri keşfetmesine, zenginleştirmesine ve nitelendirmesine izin verin.",
    active: "Aktif",
    enable: "Otopilotu etkinleştir",
    enable_hint: "Arka planda her gün saat {{hour}}:00 UTC'de çalışır. Yeni potansiyel müşteriler hazır olduğunda bildirim alırsınız.",
    mode: "Prospeksiyon modu",
    mode_find_customers: "Müşteri bul",
    mode_find_customers_hint: "Her Müvekkil için Potansiyel Müşteri bul (pitch olarak ürün/hizmetlerini kullanır)",
    mode_find_principals: "Müvekkil bul",
    mode_find_principals_hint: "Acente olarak temsil edebileceğiniz şirketleri bulun",
    mode_both: "Her ikisi",
    mode_both_hint: "Her çalıştırmada Müvekkiller + Müşteriler",
    countries: "Hedef ülkeler",
    sectors: "Hedef sektörler",
    any: "Herhangi",
    criteria: "Ek kriterler",
    criteria_placeholder: "ör. Series A/B, 50-200 çalışan, B2B SaaS…",
    min_score: "Min AI skoru",
    max_per_run: "Çalıştırma başına maks.",
    actions_per_run: "Zincirlenecek aksiyonlar",
    auto_enrich: "Otomatik zenginleştir (AI analizi + kaynaklar)",
    auto_find_dms: "Karar vericileri bul (Apollo + AI yedek)",
    last_runs: "Son çalıştırmalar",
    created_label: "eklendi",
    enriched_label: "zenginleştirildi",
    run_now: "Şimdi çalıştır",
    saved: "Yapılandırma kaydedildi",
    skipped: "Atlandı: {{reason}}",
    error: "Hata",
    run_done: "{{created}} potansiyel müşteri eklendi, {{enriched}} zenginleştirildi",
    running_bg: "Otopilot arka planda başlatıldı. Sonuç ~30sn içinde.",
  },
  email: {
    compose_title: "AI E-posta Yazıcısı",
    no_contact_selected: "Kişi seçilmedi",
    no_recipient: "Bu kişi için e-posta yok",
    tone: "Ton",
    tone_formal: "Resmi",
    tone_casual: "Samimi",
    tone_urgent: "Doğrudan ve acil",
    include_signals: "Son web sinyallerini dahil et",
    include_signals_hint: "Kişiselleştirme için en son Tavily haberlerini (yatırım, işe alım, IPO…) kullanır.",
    custom_brief: "Ek brief (isteğe bağlı)",
    custom_brief_placeholder: "ör. son perakende vaka çalışmamızdan bahset",
    generate: "Taslak oluştur",
    regenerate: "Yeniden oluştur",
    generating: "Oluşturuluyor…",
    draft_ready: "Taslak hazır — göndermeden önce gözden geçirin",
    subject: "Konu",
    body: "E-posta gövdesi",
    preview: "Önizleme",
    edit: "Düzenle",
    send: "Gönder",
    sending: "Gönderiliyor…",
    sent_to: "E-posta {{email}} adresine gönderildi",
    signals_used: "Kullanılan web sinyalleri",
    history_title: "Gönderilen e-postalar",
    validating: "Doğrulanıyor…",
    validation_valid: "Geçerli e-posta",
    validation_risky: "Riskli",
    validation_invalid: "Geçersiz e-posta",
    validation_unknown: "Doğrulanmamış",
    blocked_title: "Gönderim engellendi — geçersiz adres",
    blocked_hint: "Bu adres otomatik doğrulamayı geçemedi. Kişinin e-postasını düzeltin veya Ayarlarda doğrulamayı kapatın.",
    blocked_invalid: "Gönderim engellendi — geçersiz adres ({{flags}})",
    followup_label: "Otomatik takip planla",
    followup_hint: "AI takibi taslaklaştıracak ve onayınız için kuyruğa alacak — sıfır otomatik gönderim.",
    followup_days_unit: "gün",
    fu_scheduled: "Takip planlandı",
    fu_sent: "Takip gönderildi",
    fu_drafted_pending: "Taslak onay bekliyor",
    fu_cancelled: "Takip iptal edildi",
    fu_skipped_opened: "E-posta açıldı — takip atlandı",
    fu_skipped_bounced: "Geri döndü — takip atlandı",
    fu_skipped: "Takip atlandı",
    fu_error: "Takip hatası",
    fu_due_at: "{{date}} tarihinde",
    fu_send_now: "Şimdi gönder",
    fu_cancelled_ok: "Takip iptal edildi",
    fu_sent_ok: "Takip gönderildi",
  },
  approvals: {
    title: "E-posta Onayları",
    subtitle: "Gönderilmeden önce AI tarafından oluşturulan her takibi inceleyin ve onaylayın.",
    queue: "Kuyruk",
    empty_title: "Bekleyen onay yok",
    empty_hint: "AI bir takip hazırladığında, göndermeden önce gözden geçirmeniz için buraya gelir.",
    select_hint: "İncelemek için listeden bir takip seçin.",
    approve_send: "Onayla ve gönder",
    reject: "Reddet",
    save_edit: "Kaydet",
    edit_saved: "Düzenlemeler kaydedildi",
    approved_ok: "E-posta gönderildi",
    rejected_ok: "Takip reddedildi",
    confirm_reject: "Bu takip kalıcı olarak reddedilsin mi?",
    confirm_approve: "Bu e-posta şimdi {{email}} adresine gönderilsin mi?",
    expires_on: "{{date}} tarihinde sona erer",
  },
  email_perf: {
    title: "E-posta Performansı",
    subtitle: "Etkileşimi takip edin: açılmalar, tıklamalar, en iyi gönderim saatleri, kazanan konular.",
    sent: "Gönderildi",
    delivered: "Teslim edildi",
    delivered_n: "teslim edildi",
    open_rate: "Açılma oranı",
    click_rate: "Tıklama oranı",
    bounce_rate: "Geri dönüş oranı",
    opens: "açılma",
    clicks: "tıklama",
    bounces: "geri dönüş",
    over_days: "{{d}} gün boyunca",
    timeline: "Zaman çizelgesi",
    heatmap: "En iyi gönderim saatleri (açılma oranı)",
    heatmap_hint: "Renk ne kadar parlaksa, o slot'taki açılma oranı o kadar iyidir.",
    top_subjects: "En iyi konular (açılma oranı)",
    top_companies: "En etkileşimli şirketler",
    reply_rate_soon_title: "Yanıt oranı — yakında",
    reply_rate_soon_hint: "Gelen yanıtları otomatik algılamak için Gmail/Outlook entegrasyonu gerektirir.",
    coming_soon: "Yakında",
  },
  validation: {
    title: "E-posta doğrulama",
    description: "Geri dönüş önleme hattı: format → MX DNS (ücretsiz, sınırsız) → NeverBounce (premium, riskli durumlar için).",
    active: "Aktif",
    not_configured: "Yapılandırılmamış",
    low_balance: "Düşük bakiye",
    free_credits: "Ücretsiz",
    paid_credits: "Ücretli",
    total_credits: "Toplam",
    pipeline_hint: "Format/MX aşamasında zaten geçersiz olan e-postalar SIFIR NeverBounce kredisi tüketir.",
    skip_label: "Gönderim öncesi doğrulamayı devre dışı bırak",
    skip_hint: "Yalnızca liste kalitenizden %100 eminseniz etkinleştirin. Resend ban riski artar.",
  },
  dataprep: {
    title: "Veri hazırlığı",
    subtitle: "Verilerinizi yedekleyin, ardından Faz 2'den önce demo veritabanını silin.",
    step1_title: "Adım 1 — Mevcut verilerinizi yedekleyin",
    step1_hint: "Koleksiyon başına bir CSV içeren bir ZIP indirin (şirketler, kişiler, anlaşmalar, e-postalar, …). Güvende tutun.",
    business_data: "İş verisi (silinecek)",
    kept_data: "Saklanan veri",
    kept_hint: "Kullanıcılarınız, şifreleriniz, sektörleriniz ve ülkeler referans verisi sağlam kalır.",
    download_zip: "Tam ZIP arşivini indir",
    exporting: "Arşiv oluşturuluyor…",
    export_ok: "Arşiv indirildi — güvende tutun",
    export_ok_suffix: "indirildi",
    export_fail: "Dışa aktarma başarısız",
    step2_title: "Adım 2 — İş verisini sil (geri alınamaz)",
    step2_hint: "Bu, tüm şirketleri, kişileri, anlaşmaları, gönderilen e-postaları, sinyalleri ve bildirimleri kaldırır. Kullanıcı hesaplarınız ve sektörler/ülkeler korunur.",
    start_wipe: "Silme prosedürünü başlat",
    confirm_title: "⚠ Geri alınamaz eylem",
    confirm_bullet1: "Tüm şirketler ve kişileri silinecek",
    confirm_bullet2: "E-posta geçmişi, bildirimler ve AI sinyalleri silinecek",
    confirm_bullet3: "Kullanıcı hesaplarınız, sektörler ve ülkeler sağlam kalır",
    type_to_confirm: "Onaylamak için tam olarak yazın: {{token}}",
    confirm_wipe: "Silmeyi onayla",
    wiping: "Silme devam ediyor…",
    wipe_ok: "Veri silindi ({{n}} belge) — şimdi temiz başlayabilirsiniz",
    popup_blocked: "Açılır pencere engellendi — bu site için açılır pencerelere izin verin ve yeniden deneyin.",
    popup_hint: "İndirme bu sekmede başlayacak… kapatmayın.",
    export_triggered: "İndirme yeni bir sekmede tetiklendi — İndirilenler klasörünüzü kontrol edin.",
    token_not_ready: "Güvenli bağlantı hazırlanıyor… 2 saniye sonra yeniden deneyin.",
    token_loading: "Güvenli bağlantı hazırlanıyor…",
    fallback_title: "Yedek ZIP indir",
    fallback_hint: "Emergent editörü iframe'den doğrudan indirmeleri engeller. Aşağıdaki URL'yi kopyalayın ve yeni bir Chrome sekmesine yapıştırın:",
    fallback_step1: "Aşağıdaki \"Kopyala\"ya tıklayın",
    fallback_step2: "Yeni bir Chrome sekmesi açın (Ctrl+T) — editörün İÇİNDE DEĞİL",
    fallback_step3: "URL'yi yapıştırın (Ctrl+V) sonra Enter — ZIP indirilir",
    token_expires_hint: "Bağlantı 5 dk içinde sona erer — her 4 dk otomatik yenilenir.",
    copy: "Kopyala",
    url_copied: "URL kopyalandı — yeni bir Chrome sekmesine yapıştırın",
  },
  resend_domain: {
    title: "Gönderen alan adı (Resend)",
    subtitle: "Herhangi bir adrese özet göndermek için alan adınızı doğrulayın (varsayılan olarak yalnızca doğrulanmış e-postanız testleri alır).",
    current_sender: "Mevcut gönderen adresi",
    test_mode: "Test modu",
    test_mode_hint: "Test modunda, yalnızca Resend hesabınızda doğrulanmış adresler e-posta alır. Herkese göndermek için bir alan adı doğrulayın.",
    add_domain: "Alan adı ekle",
    add: "Ekle",
    added: "Alan adı eklendi — aşağıdaki DNS kayıtlarını yapılandırın",
    existed: "Alan adı Resend'de zaten var",
    your_domains: "Alan adlarınız",
    check: "Kontrol et",
    verify_triggered: "Doğrulama tetiklendi",
    dns_records_title: "Kayıt sağlayıcınıza eklenecek DNS kayıtları",
    dns_hint: "Bu 3 kaydı Cloudflare/OVH/Namecheap'te kopyalayın, ardından « Kontrol et »e tıklayın.",
    use_as_sender: "Gönderen olarak kullan",
    sender_set: "Gönderen ayarlandı: {{email}}",
    open_dashboard: "Resend gösterge panelini aç",
  },
  mandant_dna: {
    title: "Müvekkil DNA — {{name}}",
    intro: "AI, Müvekkilin web sitesini derinlemesine okuyacak ve gerçek işlerini anlayacak: ürünler/hizmetler, hedef endüstriler, alıcı profilleri, rakipler.",
    intro_step1: "10 adede kadar anahtar sayfanın otomatik keşfi (ana sayfa, ürünler, çözümler, referanslar)",
    intro_step2: "Tavily üzerinden içerik çıkarma ve Claude (Anthropic) tarafından analiz",
    intro_step3: "Müvekkile uygulamadan önce inceleyebileceğiniz yapılandırılmış profil",
    website_label: "Analiz edilen web sitesi",
    no_website: "(kayıtlı web sitesi yok)",
    warn_no_website: "Önce Müvekkile bir web sitesi ekleyin.",
    analyze_btn: "Analizi çalıştır",
    analyzing_title: "Analiz ediliyor…",
    analyzing_hint: "Crawl + AI — tam bir site için yaklaşık 60 saniye.",
    meta_pages: "{{count}}/{{total}} sayfa okundu",
    section_pitch: "Pitch özeti",
    section_products: "Ürünler ve hizmetler",
    section_industries: "Son endüstriler",
    section_sectors: "Önerilen CRM sektörleri",
    section_buyers: "Alıcı profili",
    section_competitors: "Tespit edilen rakipler",
    section_keywords: "Prospeksiyon anahtar kelimeleri",
    section_redflags: "Uyarılar",
    buyer_size: "Şirket büyüklüğü",
    buyer_geo: "Coğrafi güç",
    buyer_roles: "Karar rolleri",
    buyer_use_cases: "Tipik kullanım senaryoları",
    cancel: "İptal",
    rerun: "Yeniden çalıştır",
    apply: "Müvekkile uygula",
    applied: "Profil uygulandı ({{fields}} alan, {{sectors}} sektör bağlandı)",
    subsectors_created: "{{count}} yeni alt-sektör oluşturuldu",
    error_extract: "İçerik çıkarılamadı: {{error}}",
  },
  market_intel: {
    title: "Pazar İstihbaratı",
    subtitle: "Ülke düzeyinde stratejik brief: projeler, alıcılar, rakipler, yeni Müvekkil edinimi için kapsama boşlukları.",
    country: "Hedef ülke", pick_country: "Bir ülke seçin…",
    sector_hint: "Sektör (isteğe bağlı)", sector_placeholder: "ör. Su ve Tuzdan Arındırma",
    generate: "Brief oluştur", refresh: "Yenile",
    analyzing: "Analiz ediliyor…",
    analyzing_hint: "6 web araması + AI sentezi — yaklaşık 90 saniye",
    from_cache: "Yakın brief önbellekten yüklendi (< 7 gün)",
    generated: "Brief oluşturuldu ✓",
    cached_label: "önbellekten",
    section_macro: "Makro genel bakış",
    section_sectors: "Büyüyen sektörler",
    section_projects: "Mega projeler",
    section_buyers: "En iyi B2B alıcılar",
    section_competitors: "Ülkedeki aktif rakipler",
    section_gaps: "Kapsama boşlukları (Müvekkil fırsatları)",
    section_tenders: "Yaklaşan ihaleler",
    gap_ideal: "İdeal Müvekkil profili",
    gap_pitch: "Pitch açısı",
    generate_pitch_pdf: "Pitch deck oluştur",
  },
  pitch_deck: {
    title: "Pitch deck oluştur",
    candidate_name: "Aday Müvekkil adı",
    candidate_placeholder: "ör. Wabag",
    candidate_url: "Web sitesi (isteğe bağlı)",
    start: "Oluştur",
    running: "Oluşturuluyor…",
    generating: "Claude 4 slaytı yazıyor… ~90sn",
    download_pdf: "PDF'i indir",
  },
  quality: {
    title: "Kalite Denetimi",
    subtitle: "Doğrulanmamış kişileri ve karar vericisi olmayan şirketleri tespit edin. Toplu Hunter.io doğrulaması çalıştırın.",
    kpi_contacts_verified: "Doğrulanmış kişiler",
    kpi_contacts_unverified: "Doğrulanmamış",
    kpi_contacts_no_email: "E-postası olmayan",
    kpi_companies_no_dm: "KV'si olmayan",
    section_companies_no_dm: "Karar vericisi olmayan şirketler",
    actionable_count: "{{total}} arasından {{actionable}} işlem yapılabilir (web sitesi olan)",
    selected: "{{count}} seçildi",
    bulk_verify_via_hunter: "Hunter ile doğrula",
    bulk_max: "Toplu başına maksimum 50 şirket.",
    bulk_done: "Denetim tamamlandı: {{companies}} şirkette {{contacts}} yeni kişi eklendi.",
    all_companies_have_dm: "Her şirkette en az bir karar verici var. 🎉",
    all_contacts_verified: "Tüm kişiler doğrulandı. 🎉",
    section_unverified_contacts: "Doğrulanmamış kişiler",
    no_dm: "Karar verici yok",
    no_website: "Web sitesi yok",
    col_website: "Web sitesi",
    col_status: "Durum",
    run_hunter: "Hunter.io ile karar vericileri ara",
    no_website_for_hunter: "Hunter.io'yu çalıştırmak için şirkete bir web sitesi ekleyin.",
    hunter_found: "{{count}} karar verici {{provider}} üzerinden bulundu ✓",
    hunter_pattern_only: "Karar verici bulunamadı, ancak e-posta deseni algılandı: {{pattern}}",
    hunter_none: "Hunter.io ile karar verici bulunamadı. Manuel aramak için LinkedIn'i kullanın.",
    tavily_cleanup_title: "Kirli web içe aktarmaları tespit edildi",
    tavily_cleanup_subtitle: "Tavily üzerinden içe aktarılan {{count}} şirket gerçek şirket değil, makale veya rehber gibi görünüyor. İncelenen: {{examined}}.",
    tavily_cleanup_delete: "Sil ({{count}})",
    cleanup_confirm: "{{count}} kirli giriş kalıcı olarak silinsin mi? Bu geri alınamaz.",
    cleanup_done: "{{count}} kirli giriş silindi ✓",
  },
  api_credits: {
    title: "API kredileri ve kotaları",
    subtitle: "Uygulama tarafından kullanılan her harici hizmet için anahtarların durumu ve kalan krediler.",
    refresh: "Yenile",
    summary_title: "{{ok}} / {{total}} hizmet çalışır durumda",
    configured_count: "{{total}} arasından {{configured}} anahtar yapılandırıldı",
    checked_at: "Kontrol zamanı {{time}}",
    not_configured: "Yapılandırılmamış",
    ok: "Tamam",
    error: "Hata",
    manage: "Anahtarı yönet",
    searches_month: "Bu ay aramalar",
    verifications_month: "Bu ay doğrulamalar",
    paid_credits: "Ücretli krediler",
    free_credits: "Ücretsiz krediler",
    reset_on: "{{date}} tarihinde sıfırlanır",
  },
  api_alerts: {
    view: "Görüntüle",
    dismiss: "Kapat",
    more_count: "diğer hizmetlerde +{{count}} başka uyarı",
    toast_description: "API kredilerini kontrol edin.",
    msg_warning_quota: "{{name}}: bu ay {{remaining}}/{{total}} istek kaldı (%{{pct}}).",
    msg_warning_credits: "{{name}}: yalnızca {{remaining}} kredi kaldı.",
    msg_critical_quota: "{{name}}: kritik — {{remaining}}/{{total}} istek (%{{pct}}).",
    msg_critical_credits: "{{name}}: kritik — {{remaining}} kredi kaldı.",
    msg_over: "{{name}}: aylık kota aşıldı ({{total}} istek). Sıfırlanana kadar hizmet engellendi.",
    msg_error: "{{name}}: hizmet hatası. {{error}}",
  },
};

export default tr;
